import React from 'react';
import { useSelector } from 'react-redux';
import { LoginView, ChatView } from '../components';

const TaskPaneView = () => {
  const isAuthenticated = true;//process.env.NODE_ENV === 'development' ? true : useSelector(state => state.user.isAuthenticated);
  // const isAuthenticated = true;
  return (
    <div style={{ height: '100vh', background: '#F4F6F8', display: 'flex', flexDirection: 'column' }}>
      {isAuthenticated ? <ChatView /> : <LoginView />}
    </div>
  );
};

export default TaskPaneView; 